import axiosInstance from './axios-instance';

export const getStartScreenData = (locationId: string) => axiosInstance.get('/dashboard/start-screen-data', { params: { locationId }});
